export const industries = [
  {
    slug: 'manufacturing',
    title: 'Manufacturing',
    summary: 'Operational continuity, supply chain resilience, and protection architecture for complex production environments.',
  },
  {
    slug: 'healthcare',
    title: 'Healthcare',
    summary: 'Clinical and operational resilience for hospitals, providers, and health systems under continuous pressure.',
  },
  {
    slug: 'financial-services',
    title: 'Financial Services',
    summary: 'Operational and cyber resilience for institutions where trust, continuity, and regulatory confidence are non-negotiable.',
  },
  {
    slug: 'technology',
    title: 'Technology',
    summary: 'Digital risk, cyber resilience, and enterprise readiness for fast-moving technology organizations.',
  },
  {
    slug: 'energy',
    title: 'Energy',
    summary: 'Infrastructure resilience and risk intelligence for energy operators navigating physical and transition risk.',
  },
  {
    slug: 'infrastructure',
    title: 'Infrastructure',
    summary: 'Continuity and protection strategies for critical infrastructure that societies and economies depend on.',
  },
  {
    slug: 'retail',
    title: 'Retail',
    summary: 'Supply chain, cyber, and operational resilience for omnichannel retail organizations.',
  },
  {
    slug: 'logistics',
    title: 'Logistics',
    summary: 'Network continuity and disruption readiness for logistics and transportation operators.',
  },
  {
    slug: 'pharma',
    title: 'Pharma',
    summary: 'Quality, supply, and operational resilience for pharmaceutical and life sciences enterprises.',
  },
  {
    slug: 'education',
    title: 'Education',
    summary: 'Campus, cyber, and continuity resilience for educational institutions.',
  },
  {
    slug: 'government',
    title: 'Government',
    summary: 'Public-sector resilience architecture for continuity of critical citizen services.',
  },
  {
    slug: 'bfsi',
    title: 'BFSI',
    summary: 'Banking, financial services, and insurance sector resilience—governance, cyber, and operational readiness.',
  },
];

export const getIndustryBySlug = (slug) =>
  industries.find((i) => i.slug === slug);
